<template>
  <div class='page_middle_container assignLeader_container' v-loading.fullscreen.lock="loadingData">
    <div class='page_middle_title'>
      指定项目Leader
    </div>
    <div class='projectAssignLeader_page_middle_content'>
      <div>
        <div class='project_execute_page_middle_row'>
          <div class="project_execute_middle_row_block">
            <div class='projectExecuteComponents_page_middle_row_key'><span
                class="page_middle_row_key_required">*</span>项目号：</div>
            <div class='projectAssignLeader_page_middle_row_value'>
              <el-input disabled v-model.trim="data.project_number" placeholder="请输入项目号"></el-input>
            </div>
          </div>
        </div>
        <div class='project_execute_page_middle_row'>
          <div class="project_execute_middle_row_block">
            <div class='projectExecuteComponents_page_middle_row_key'><span
                class="page_middle_row_key_required">*</span>需求名称：</div>
            <div class='projectAssignLeader_page_middle_row_value'>
              <el-input :disabled="true" v-model.trim="data.demand_name" placeholder="请输入需求名称"></el-input>
            </div>
          </div>
        </div>
        <div class='project_execute_page_middle_row'>
          <div class="project_execute_middle_row_block">
            <div class='projectExecuteComponents_page_middle_row_key' style="text-align: right;"><span
                class="page_middle_row_key_required">*</span>需求编号：</div>
            <div class='projectAssignLeader_page_middle_row_value'>
              <el-input :disabled="true" v-model.trim="data.demand_number" placeholder="请输入需求编号"></el-input>
            </div>
          </div>
        </div>
        <div class='project_execute_page_middle_row'>
          <div class="project_execute_middle_row_block">
            <div class='projectExecuteComponents_page_middle_row_key' @click="show = !show"><span
                class="page_middle_row_key_required">*</span>需求类型：</div>
            <div class='projectAssignLeader_page_middle_row_value'>
              
              <el-select class="leader_select" :disabled="true" v-model="data.task_type" placeholder="需求类型">
                <el-option v-for="(item, index) in config.projectType" :key="index" :value="item.index" :label="item.label"></el-option>
              </el-select>

              <!-- <el-radio-group :disabled="true" v-model="data.task_type">
                <el-radio v-for="(item, index) in config.projectType" :key="index" :label="index" size="small">
                  {{ item }}</el-radio>
              </el-radio-group> -->
              <div style="margin-left: 4vw;" v-if="data.task_type != 0 && !$tools.isNewProjectExe(this.created_time)">
                <el-button type="primary" @click="show = !show" size="small">{{ show ? "点击收起" : "点击展开" }}</el-button>
              </div>
            </div>
          </div>
        </div>
        <!-- <platformSynthesis :isWatch="isWatch"></platformSynthesis> -->
        <el-collapse-transition>
          <component v-show="show" v-if="components" v-bind:is="components" ref="project_execute_components" :isWatch="true"
            :subTaskData="subTaskData" :taskType="cacheTaskType"></component>
        </el-collapse-transition>
        <div class='project_execute_page_middle_row'>
          <div class="project_execute_middle_row_block" style="align-items: flex-start;">
            <div class='projectExecuteComponents_page_middle_row_key'>需求说明：</div>
            <div class='projectAssignLeader_page_middle_row_value'>
              <div style="border: 1px solid #ccc;word-break: break-all;width: 100%;">
                  <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor['requirement']" :defaultConfig="toolbarConfig"
                      :mode="mode" />
                  <Editor style="height: 300px; overflow-y: hidden;" v-model="data.requirement"
                      :defaultConfig="editorConfig" :mode="mode" @onCreated="(editor)=>{onCreated(editor,'requirement')}" />
              </div>
              <!-- <el-input :disabled="true" type="textarea" v-model="data.requirement" rows="4"
                placeholder="请输入需求补充说明"></el-input> -->
            </div>
          </div>
        </div>
        <div class='project_execute_page_middle_row' style="margin-bottom: 0;">
          <div class="project_execute_middle_row_block" style="align-items:flex-start">
            <div class='page_middle_row_attachment_key'
              style="height: 10vw;display: flex;flex-direction: column;justify-content: center; align-items: flex-end;">附件：
            </div>
            <div class='projectAssignLeader_page_middle_row_value'>
              <Attachment class="zIndexBold" @changeFile="changeFile" @deleteFile="deleteFile" :isLink=true
                :showUpload="false" :files="requirement_attachment" type="project" :required="config.isRequired">
              </Attachment>
            </div>
          </div>
        </div>
        <div class='project_execute_page_middle_row'>
          <div class="project_execute_middle_row_block">
            <div class='projectExecuteComponents_page_middle_row_key'>指定Leader:</div>
            <div class='projectAssignLeader_page_middle_row_value'>
              <el-select class="leader_select" :disabled="isWatch" v-model="data.specify_leader" filterable placeholder="是否指定Leader">
                <el-option :value="1" label="是"></el-option>
                <el-option :value="0" label="否"></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="projectAssignLerder_table">
          <div class="projectAssignLerder_table_tr">
            <div class="projectAssignLerder_table_leader">Leader类型</div>
            <div class="projectAssignLerder_table_name">姓名</div>
            <div class="projectAssignLerder_table_remark">备注</div>
            <div class="projectAssignLerder_table_controls">操作</div>
          </div>
          <div class="projectAssignLerder_table_tr" v-for="(leaders, index) in data.leaders" :key="index">
            <div class="projectAssignLerder_table_leader">
              <el-select :disabled="isWatch||!data.specify_leader" @change="changeLeader(leaders)" v-model="leaders.leader_type"
                placeholder="Leader类型">
                <el-option v-for="(department, index) in config.department" :key="index" :value="Number(index)"
                  :label="department"></el-option>
              </el-select>
            </div>
            <div class="projectAssignLerder_table_name">
              <el-select :disabled="isWatch||!data.specify_leader || leaders.leader_type !== '' && canChangeLeader(leaders)"
                v-model="leaders.user_id" filterable placeholder="Leader姓名">
                <el-option v-for="(staff, index) in config.staff_list[leaders.leader_type]" :key="index" :value="staff.id"
                  :label="staff.name"></el-option>
              </el-select>
            </div>
            <div class="projectAssignLerder_table_remark">
              <el-input :disabled="isWatch||leaders.leader_type!==''&&leaders.leader_type != config.taskTypeDepartmentMap[data.task_type]" v-model.trim="leaders.remark"
                :placeholder="isWatch||leaders.leader_type!==''&&leaders.leader_type != config.taskTypeDepartmentMap[data.task_type] ? '暂无' : '请输入备注'"></el-input>
            </div>
            <div class="projectAssignLerder_table_controls">
              <div class="add_operation_icon">
                <el-icon @click="addLeader">
                  <CirclePlusFilled />
                </el-icon>
              </div>
              <div class="del_operation_icon">
                <el-icon v-if="data.leaders.length>1" @click="delLeader(index)">
                  <RemoveFilled />
                </el-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class='page_middle_buttongroup' v-if="!isWatch">
        <el-button type="primary" @click="doCommit(2)" :loading="loadingData" size="small">发送本部门修改</el-button>
        <el-button type="primary" @click="doCommit(0)" :loading="loadingData" size="small">发送跨部门</el-button>
        <el-button type="primary" @click="doCommit(1)" :loading="loadingData" size="small">发送客户部</el-button>
      </div>
      <!-- <div class="global_value_mask"></div> -->
    </div>
  </div>
</template>
<script>
import { CirclePlusFilled, RemoveFilled } from "@element-plus/icons";
import Attachment from "@/components/unit/attachment";
//平台综合类
import platformSynthesis from "@/components/page/project/projectExecuteComponents/platformSynthesis";
import medicalMaterials from "@/components/page/project/projectExecuteComponents/medicalMaterials";
import visualizationTask from "@/components/page/project/projectExecuteComponents/visualizationTask";
import projectExecuteTask from "@/components/page/project/projectExecuteComponents/projectExecuteTask";
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { ElCollapseTransition } from "element-plus";
export default {
  name: 'page_middle',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    components() {
      // if(this.data.task_type) return "projectExecuteTask"
      return this.$tools.isNewProjectExe(this.created_time)?"platformSynthesis":this.config.projectComponent[this.data.task_type];
    }
  },
  components: {
    Editor,
    Toolbar,
    Attachment,
    platformSynthesis,
    medicalMaterials,
    visualizationTask,
    projectExecuteTask,
    RemoveFilled,
    CirclePlusFilled,
    ElCollapseTransition,
  },
  data() {
    return {
      data: {
        project_id: '',
        project_number: "",
        demand_name: "",
        demand_number: "",
        task_type: 0,
        requirement: "",
        requirement_attachment: "",
        specify_leader: 1,//是否指定leader
        is_send: 0,
        leaders: []
      },
      config: {
        taskTypeMap:{
          //线上会议（含飞派，研讨会定制模式）指派人袁哥---能选的leader类型为：开发/其他、AIGCT具/文献整理/数据、设计、项目执行
          0:[0,2,3,4],
          //医学物料定制 指派人李露薇---能选的leader类型为：医学
          1:[1],
          //仅设计或美化需求 指派人罗冠明---能选的leader类型为：设计、项目执行
          2:[2,3],
          //非线上会议的执行 指派人罗冠明---能选的leader类型为：设计、项目执行
          3:[2,3],
          //IT开发定制 指派人袁哥---能选的leader类型为：开发/其他、AIGCT具/文献整理/数据、设计、项目执行
          4:[0,2,3,4],
          //医学研究类 指派人金海欣---能选的leader类型为：全部
          5:[0,1,2,3,4,5],
          //AI定制类 指派人袁哥---能选的leader类型为：开发/其他、AIGCT具/文献整理/数据、设计、项目执行
          6:[0,2,3,4],
          //医学物料定制 指派人李露薇---能选的leader类型为：医学
          7:[1],
          //AI工具账号类 指派人相菊---能选的leader类型为：
          8:[],
          //学术会议/可视化类类 指派人罗冠明---能选的leader类型为：设计、项目执行
          9:[2,3]
        },
        //每个类型允许指派的leader
        taskTypeMapLeader:{
          0:"袁振华",
          1:"李露薇",
          2:"罗冠明",
          3:"罗冠明",
          4:"袁振华",
          5:"金海欣",
          6:"袁振华",
          7:"李露薇",
          8:"黄相菊",
          9:"罗冠明"
        },
        department: {
          0:"开发/其他",
          1:"医学",
          2:"设计",
          3:"项目执行",
          4:"AIGC工具/文献整理/数据",
          5:"医学研究",
        },
        taskTypeDepartmentMap:{
          0:0,//"开发/其他"
          1:1,//"医学"
          2:1,//"设计"
          3:3,//"项目执行"
          4:4,//"AIGC工具/文献整理/数据"
          5:5,//"医学研究"
          6:0,//"开发/其他"
          7:1,//"医学"
          8:4,//"AIGC工具/文献整理/数据"
          9:3//"项目执行"
        },
        staff_list:[],
        defaultLeader: {
          0:"袁振华",
          1:"李露薇",
          2:"罗冠明",
          3:"罗冠明",
          4:"黄相菊",
          5:"金总"
        },//默认Leader与上方部门一一对应
        projectComponent: [
          "platformSynthesis",
          "medicalMaterials",
          "visualizationTask",
          "projectExecuteTask",
          "platformSynthesis",
          "platformSynthesis"
        ],
        newProjectComponent: [
          "platformSynthesis",
          "platformSynthesis",
          "platformSynthesis",
          "platformSynthesis",
          "platformSynthesis",
          "platformSynthesis"
        ],
        projectType:this.$config.types.newProjectDemandType,
        isRequired: {
          isRequired: false,
          title: "",
        },
      },
      toolbarConfig: this.$config.toolbarConfig,
      mode: 'default', // or 'simple'
      editorConfig: { placeholder: '请输入内容...' },
      editor: {
        requirement:null
      },
      created_time:"",
      show: true,
      // department: "",//部门
      cacheTaskType: -1,
      subTaskData: {},
      isWatch: false,
      loadingData: false,
      requirement_attachment: [],
    }
  },
  created() {
    this.query = { ...this.$route.query };
    // this.department = isNaN(Number(this.query.department)) ? "" : this.config.department[Number(this.query.department)];
    this.isWatch = !!this.query.isWatch||!!this.item.isWatch;
    let id = this.query.id == undefined ? this.item.operation_table_id : this.query.id;
    this.loadData(id);
  },
  mounted() {
  },
  methods: {
    async changeLeader(leaderData) {
      if(!this.config.staff_list[leaderData.leader_type]){
        await this.loadStaff(leaderData);
      }
      let leader_name = this.config.defaultLeader[leaderData.leader_type];//获取对应leader类型默认的负责人
      let leaders = this.config.staff_list[leaderData.leader_type].find(x => x.name.includes(leader_name));
      if (leaders) {
        leaderData.user_id = leaders.id;
      }
    },
    canChangeLeader(leader){
      return !this.config.taskTypeMap[this.data.task_type].includes(leader.leader_type)
    },
    loadStaff(leaderData) {
      return new Promise((resolve, reject) => {
        if(this.config.staff_list[leaderData.leader_type] && this.config.staff_list[leaderData.leader_type].length > 0){
          resolve(true);
          return;
        }
        this.loadingData = true;
        let url = this.$tools.getURL(this.$urls.projectExecute.get_task_worker_list, { leader_type: leaderData.leader_type });
        this.$axios.get(url).then(res => {
          this.config.staff_list[leaderData.leader_type] = res.data;
          this.loadingData = false;
          resolve(true);
        }).catch(() => {
          this.$tips.error({ text: "获取Leader列表失败" });
          this.loadingData = false;
          reject(false);
        })
      })
    },
    isDisabled(){
      let userInfo = this.$store.state.common.userInfo  || {};
      //没有登录或者登录用户的名字中不包含当前类型可指派的leader的名字，则禁用
      return !userInfo.name || !userInfo.name.includes(this.config.taskTypeMapLeader[this.data.task_type]);
    },
    backIndex(cancel_status) {
      let text = this.$config.types.cancelStatusTips[cancel_status]
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: false,
        customClass: "customClass",
        cancelButtonClass: "cancelButtonClass",
        type: "info",
      }).then(() => {
        // this.$router.push({ path: "/", });
        // this.$emit("doClose", true);
      }).catch(() => {
        // this.$router.push({ path: "/", });
        // this.$emit("doClose", true);
      });
    },
    loadData(id) {
      this.loadingData = true;
      let url = this.$tools.getURL(this.$urls.projectExecute.get_task_work_detail, { id: id,leader_type:""});
      this.$axios.get(url).then(async (res) => {
          this.loadingData = false;
          this.data = res.data;
          this.created_time = res.data.created_time?new Date(res.data.created_time).getTime():new Date().getTime();
          if(this.$tools.isNewProjectExe2(this.created_time)){
            this.config.projectType = this.$config.types.newProjectDemandType;
          }else{
            this.config.projectType = this.$config.types.projectDemandType;
          }
          this.subTaskData = res.data.sub_task;
          this.isWatch = this.isDisabled() || this.isWatch;
          this.requirement_attachment = res.data.requirement_attachment?res.data.requirement_attachment.split(","):[];
          this.data.project_number = res.data.project_number;
          //撤销状态 0 未申请 1申请中 2 审批通过 3 审批不通过
          if([1,2].includes(this.data.cancel_status)){
            this.backIndex(this.data.cancel_status);
            return
          }
          if (this.data.leaders.length == 0) {
            let leader =
            {
              leader_type: this.config.taskTypeDepartmentMap[this.data.task_type],
              user_id: "",
              remark: "",
            }
            await this.changeLeader(leader);
            this.data.leaders.push(leader);
          } else {
            for (const leader of this.data.leaders) {
              await this.loadStaff(leader);
            }
          }
      }).catch((err) => {
          this.loadingData = false;
          console.log(err);
      });
    },
    onCreated(editor,key) {
        this.editor[key] = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
        this.editor[key].disable();
    },
    //新增leader
    addLeader() {
      if(this.isWatch) return;
      let leaders =
      {
        leader_type: "",
        user_id: "",
        remark: "",
      }
      this.data.leaders.push(leaders);
    },

    //删除leader
    delLeader(index) {
      if(this.isWatch) return;
      this.data.leaders.splice(index, 1)
    },
    doClose(){
        this.$emit('doClose')
    },
    // 上传附件
    changeFile(res) {
      if (res.index != 0) {
        this.requirement_attachment.splice(res.index - 1, 1,...res.data.data);
      }else{
        this.requirement_attachment = this.requirement_attachment.concat(res.data.data);
      }
      this.data.requirement_attachment = this.requirement_attachment.join(",");
    },
    // 删除附件
    deleteFile(res) {
      this.requirement_attachment.splice(res.index, 1);
      this.data.requirement_attachment = this.requirement_attachment.join(",");
    },
    verifyData() {
      let emptyLeader = this.data.leaders.filter(x=>x.leader_type===""||x.user_id==="");
      if(emptyLeader.length > 0){
        this.$tips.error({ text: '请删除Leader类型或Leader姓名为空的Leader' });
        return false
      }
      let tempLeaderList = [];
      for (const leader of this.data.leaders) {
        let tempLeader = tempLeaderList.find(x=>x.leader_type === leader.leader_type && x.user_id === leader.user_id)
        if(tempLeader){
          this.$tips.error({ text: '含有重复的的Leader，请检查' });
          tempLeaderList = [];
          return false
        }else{
          tempLeaderList.push({leader_type:leader.leader_type,user_id:leader.user_id});
        }
      }
      return true;
    },
    async doCommit(send_all) {
      if (this.loadingData || !this.verifyData()) {
        return;
      }
      let data = {
        task_id: this.query.id,
        specify_leader:this.data.specify_leader,
        send_all:send_all,
        operation_url:window.location.href,
        leaders:this.data.leaders.map(x=>{return {
          user_id:x.user_id,
          leader_type:x.leader_type,
          remark:x.remark
        }})
      }
      // console.log(data)
      this.loadingData = true;
      this.$axios.post(this.$urls.projectExecute.send_work_email,data).then(()=>{
        this.$tips.success({text:"发送任务邮件完成"})
        this.loadingData = false;
      }).catch((err)=>{
        console.log(err)
        this.$tips.error({text:"发送任务邮件失败"})
        this.loadingData = false;
      })
    },
  },

}
</script>
<style>
.projectAssignLeader_page_middle_content{
  flex: 1 0 0;
  position: relative;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  overflow: scroll;
}
.projectAssignLeader_page_middle_row_value {
  flex: 1 0 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.page_middle_row_attachment_key {
  flex: 24vw 0 0;
  text-align: right;
  margin-right: 2vw;
}

.project_execute_page_middle_row {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 2vw;
}

.leader_select {
  width: 40vw !important;
}

.operation_icon {
  flex: 16vw 0 0;
  display: flex;
  justify-content: space-between;
  padding: 0 2vw;
}

.add_operation_icon i {
  color: #3e94e5;
  font-size: 4.5vw;
  flex: 1 0 0;
}

.del_operation_icon i {
  color: red;
  font-size: 4.5vw;
  flex: 1 0 0;
}
.page_middle_buttongroup {
  height: 16vw;
  position: relative;
  /* z-index:1000; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2vw 0;
}
.page_middle_buttongroup .el-button{
  padding: 2vw;
}
.project_exe_radio_input{
  width: 30vw !important;
  /* flex: 30vw 0 0; */
  border: none;
}
.projectAssignLerder_table{
  width: 100%;
}
.projectAssignLerder_table_tr{
  display: flex;
  width: 100%;
  margin-top: 1vw;
}
.projectAssignLerder_table_tr div{
  height: 10.8vw;
  /* border: 1px solid #a1a1a1; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.projectAssignLerder_table_leader{
  flex: 30vw 0 0;
}
.projectAssignLerder_table_name{
  flex: 1 0 0;
  padding: 0 1vw;
}
.projectAssignLerder_table_remark{
  flex: 25vw 0 0;
}
.projectAssignLerder_table_controls{
  flex: 10vw 0 0;
}
</style>